import { render, staticRenderFns } from "./category-wizard-mobile.vue?vue&type=template&id=3e6a7058&scoped=true&"
import script from "./category-wizard-mobile.vue?vue&type=script&lang=ts&"
export * from "./category-wizard-mobile.vue?vue&type=script&lang=ts&"
import style0 from "./category-wizard-mobile.vue?vue&type=style&index=0&id=3e6a7058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6a7058",
  null
  
)

export default component.exports